import styled from "styled-components";

export const StyledCasinoSection = styled.div``;
